/**
 * @generated SignedSource<<9ded8af93f91c2cef8127cfbb2dec4b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PhaseItemTooltipBudgetSectionQuery$variables = {
  projectId: number;
};
export type PhaseItemTooltipBudgetSectionQuery$data = {
  readonly projects_by_pk: {
    readonly id: number;
    readonly project_rates: ReadonlyArray<{
      readonly id: number;
      readonly rate: number | null | undefined;
      readonly role_id: number;
    }>;
    readonly rate_card_id: number;
    readonly summary: ReadonlyArray<{
      readonly actual_phase_id: number | null | undefined;
      readonly minutes_phase_id: number | null | undefined;
      readonly role_id: number | null | undefined;
      readonly total_billable_minutes: number | null | undefined;
    }>;
  } | null | undefined;
};
export type PhaseItemTooltipBudgetSectionQuery = {
  response: PhaseItemTooltipBudgetSectionQuery$data;
  variables: PhaseItemTooltipBudgetSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "projectId"
      }
    ],
    "concreteType": "projects",
    "kind": "LinkedField",
    "name": "projects_by_pk",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rate_card_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "project_rates",
        "kind": "LinkedField",
        "name": "project_rates",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": "rate",
            "args": null,
            "kind": "ScalarField",
            "name": "rate_private",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "v_summary_total",
        "kind": "LinkedField",
        "name": "summary",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutes_phase_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total_billable_minutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actual_phase_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PhaseItemTooltipBudgetSectionQuery",
    "selections": (v3/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PhaseItemTooltipBudgetSectionQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6a8811245e501a6e9f2aa35077fa5a7d",
    "id": null,
    "metadata": {},
    "name": "PhaseItemTooltipBudgetSectionQuery",
    "operationKind": "query",
    "text": "query PhaseItemTooltipBudgetSectionQuery(\n  $projectId: Int!\n) {\n  projects_by_pk(id: $projectId) {\n    id\n    rate_card_id\n    project_rates {\n      id\n      role_id\n      rate: rate_private\n    }\n    summary {\n      role_id\n      minutes_phase_id\n      total_billable_minutes\n      actual_phase_id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f066e2701859dca3ada01b6a20a2f69f";

export default node;
